<template>
  <!---->
  <div class="loading-tem" id="loading">
    <!--<img :src="globalUrl + 'static/dist/img/Loading.jpg'" alt=""/>-->
    <div class="content index-content">
      <div class="id-content-inner">
        <div class="loader">
          <div class="loader-inner ball-pulse" style="display: block">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data ()
    {
        return {
          globalUrl : API.GlobalUrl
        }
    }
    ,
    methods: {
        //操作按钮事件
    }
    ,
    mounted: function () {
        //操作DOM
    }

    }
</script>

<style>
  .loading-tem{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 65px;
    right: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 99999999;
  }
  .loading-tem .content{
    width: 100%;
    text-align: center;
    height: 40px;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%,-65%);
  }
</style>



// WEBPACK FOOTER //
// src/components/template/loading.vue